import {enumType} from 'common/enumType';

export const FileStatus = enumType({
   Complete: 'Complete',
   Queued: 'Queued',
   Pending: 'Pending',
   Processing: 'Processing',
});
